import type { CreatureMetaDefaultsInput, CreatureMetaDefaultsResult } from '../types';

/** The displayed encounter AP maximum; saved rows retain their original input. */
export function compileCreatureApsTotal(itemType: string, saved: unknown): number {
    if (itemType === 'lair') return 1;
    const value = Number(saved ?? 3);
    return Math.max(3, Number.isFinite(value) ? Math.trunc(value) : 3);
}

/** Apply the creature finalizer's direct-CR, arcane-threshold, and encounter-AP defaults. */
export function compileCreatureMetaDefaults(input: CreatureMetaDefaultsInput): CreatureMetaDefaultsResult {
    let totalLevel = input.totalLevel;
    if (input.directCr !== null) {
        const cr = Math.trunc(input.directCr);
        totalLevel = cr === 0 ? null : cr;
    }
    return {
        totalLevel,
        arcaneThreshold: 1,
        apsTotal: input.hasEncounterCreatureId ? input.apsTotal ?? 3 : input.apsTotal,
    };
}
